import { render, staticRenderFns } from "./addPartsTemplate.vue?vue&type=template&id=7a9b9f9c&"
import script from "./addPartsTemplate.vue?vue&type=script&lang=js&"
export * from "./addPartsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports